import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { VisitasService } from '../services/visitas.service';

@Component({
  selector: 'app-root',
  templateUrl: './root.component.html',
  styleUrls: ['./root.component.css']
})
export class RootComponent implements OnInit {

  userLogado;

  isInvasionExpired: boolean = false;

  constructor(
    private visitService: VisitasService,
    private router: Router
  ) {}

  ngOnInit() {
    this.userLogado = JSON.parse(localStorage.getItem("user_logado"));

    this.getInvasionExpired()
  }

  ngAfterViewInit(){
    
  }

  getInvasionExpired() {
    this.visitService.getInvasionExpired().subscribe(
      resp=> {
        this.isInvasionExpired = true;
      },
      error => {
        this.isInvasionExpired = false;
      }
    );
  }

  navigateToHistorico() {
    const valor = 'exp'; // Defina o valor que deseja passar
    this.router.navigate(['/parametrizacao/historico-invasao'], { queryParams: { variavel: valor } });
    // this.router.navigate(['/parametrizacao/historico-invasao']);
  }

}
